import { getLogger } from '@cian/logger/browser';

import { ISerializableAppState } from '../../shared/common/state/app_state';
import { FastFilters } from '../fast/fast_filters';

import { IModule } from './worker';

export function init(state: ISerializableAppState, fastFilters?: FastFilters) {
  const module = require('./worker') as IModule;

  module.init(state, fastFilters).catch(error => getLogger().error(error, { domain: 'browser#init' }));
}
